import { render, staticRenderFns } from "./MeasurementsTable.vue?vue&type=template&id=2a54f0e3"
import script from "./MeasurementsTable.vue?vue&type=script&lang=ts"
export * from "./MeasurementsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports